import {Map} from 'immutable';
import moment from 'moment-timezone';

import {type ClosedLocalDateRange} from 'web-app/util/graphql/api-types';

export const convertPeriodsToDateMap = (
    periods: ClosedLocalDateRange[],
    map: Map<Date, boolean> = Map(),
): Map<Date, boolean> =>
    periods.reduce((reduction: Map<Date, boolean>, period: ClosedLocalDateRange) => {
        const from = moment(period.from).hours(12);
        const to = moment(period.to).hours(12);

        while (from.isSameOrBefore(to, 'day')) {
            reduction = reduction.set(from.toDate() as Date, true);
            from.add(1, 'day');
        }

        return reduction;
    }, map);
